"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Pages;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _rem = _interopRequireDefault(require("polished/lib/helpers/rem"));

var _Flex = _interopRequireDefault(require("../Flex"));

var _PaginationItem = _interopRequireDefault(require("./PaginationItem"));

var _paginate = _interopRequireDefault(require("./paginate"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

var Container = (0, _styledComponents.default)(_Flex.default).attrs({
  as: 'ul',
  alignItems: 'center'
}).withConfig({
  displayName: "Pages__Container",
  componentId: "sc-8dbz8a-0"
})(["margin:0;padding:0;list-style:none;> *{margin-right:", ";}"], function (_ref) {
  var variant = _ref.variant;
  return variant === 'compact' ? '0' : (0, _rem.default)(2);
});

function Pages(_ref2) {
  var variant = _ref2.variant,
      currentPage = _ref2.currentPage,
      totalPages = _ref2.totalPages,
      onPageChange = _ref2.onPageChange;
  var pages = (0, _react.useMemo)(function () {
    return (0, _paginate.default)(currentPage, totalPages);
  }, [currentPage, totalPages]); // for creating unique keys for the ellipses:

  var ellipsisCount = 0;
  return _react.default.createElement(Container, {
    variant: variant
  }, pages.map(function (page) {
    var key = page.ellipsis ? "ellipsis-".concat(ellipsisCount += 1) : "page-".concat(page.page);
    return _react.default.createElement(_PaginationItem.default, {
      page: page,
      key: key,
      onClick: onPageChange
    });
  }));
}